import { Component, HostBinding, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { clsx } from 'clsx';

import { IconComponent } from '../../icon';
import { SpinnerComponent } from '../../spinner';
import { StatusIconType, statusMapping } from '../status-mapping.helper';

@Component({
  selector: 'sb-status-icon',
  imports: [IconComponent, SpinnerComponent, TranslatePipe],
  templateUrl: './status-icon.component.html',
})
export class StatusIconComponent {
  statusMapping = statusMapping;

  @HostBinding('class')
  get statusClass() {
    return clsx(
      ['inline-flex h-8.5 w-8.5 items-center justify-center rounded-md'],
      this.status === 'Approved' && ['bg-success', 'text-success-inverted'],
      this.status === 'Declined' && ['bg-danger', 'text-danger-inverted'],
      this.status === 'Pending' && ['bg-alt', 'text-support'],
    );
  }

  @Input()
  status: StatusIconType = 'Pending';
  @Input()
  saving = false;
}
